// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3Wmtv","range":"MonthRangeSwitch_range__1fyrH","disabled":"MonthRangeSwitch_disabled__17DVk"};